export const resources = {
  InviteHeader: '',
  AppSettingsSaveSuccessfully: '',
  AppSettingsSaveError: '',
  BuyWizardDialogOptionCreateHeader: '',
  CreateAccount: ''
};
